module.exports = __webpack_public_path__ + "static/img/immortal.4593e38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ranks/immortal.png
// module id = SKyE
// module chunks = 1